import { useMutation } from '@tanstack/react-query'
import { supabase } from '../../api'

type ResetParams = {
  email: string,
  options?: any,
}

const resetPassword = async ({ email, options }: ResetParams) => {
  const { data, error } = await supabase.auth.resetPasswordForEmail(
    email,
    options,
  )

  if (error) {
    throw new Error(error.message)
  }

  return data
}

export default function useResetPassword({
  email = '',
  options = '',
}: ResetParams) {
  return useMutation((email2?: string | void) => resetPassword({
    email: email2 || email,
    options,
  }))
}
